export enum ClicktermConsentStatus {
  NO_DATA = 'NO_DATA',
  PENDING = 'PENDING',
  UNVERIFIED = 'UNVERIFIED',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED',
  OVERDUE = 'OVERDUE',
}

export interface UserClicktermClickwrapStatusDto {
  clickwrapTemplateId: string;
  clickwrapTemplateName?: string;
  reAcceptanceRequired: boolean;
  status: ClicktermConsentStatus;
  tags: string[];
  lastStatusUpdate?: string;
}
